import { QUERY_TABLES } from '@/helpers/constants';
import { getRandomNumber900000to999999 } from '@/helpers/utility';
import { executeQuery } from 'src/helpers/request';

const buildQueryTenant = ({ tenantId }) => {
  const randomTenantId = getRandomNumber900000to999999();
  return {
    data: {
      fields: {
        tenant_id: ['select'],
        tenant_name: ['select'],
        allow_supervisor: ['select'],
        business_hour_begin: ['select'],
        components: ['select'],
        holidays: ['select'],
        schedule_tool: ['select'],
        room_notice: ['select'],
        allowed_ips: ['select'],
        is_password_login: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      tenant_id: [tenantId, randomTenantId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {},
    table_name: QUERY_TABLES.TENANTS,
  };
};

const buildQueryApiKey = ({ tenantId }) => {
  const randomTenantId = getRandomNumber900000to999999();
  return {
    data: {
      fields: {
        tenant_id: ['select'],
        product: ['select'], // microsoft, verkada, meraki, butlr, garoon, webex
        apikey_id: ['select'],
        webhook_url: ['select'],
        graph_client_id: ['select'], // microsoft
        graph_tenant_id: ['select'], // microsoft
        client_id: ['select'], // webex
        subdomain: ['select'], // garoon
        username: ['select'], // butlr, garoon
        has_apikey: ['select'],
        has_client_secret: ['select'],
        has_refresh_token: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      tenant_id: [tenantId, randomTenantId],
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {},
    table_name: QUERY_TABLES.APIKEYS,
  };
};

const buildQueryAuthProvider = ({ tenantId }) => {
  const randomTenantId = getRandomNumber900000to999999();
  return {
    data: {
      fields: {
        auth_provider_id: ['select'],
        auth_provider: ['select'],
        azure_client_id: ['select'],
        azure_tenant_id: ['select'],
        has_azure_client_secret: ['select'],
      },
      skip: 0,
      limit: 0,
    },
    filter: {
      tenant_id: {
        in: [tenantId, randomTenantId],
      },
    },
    scale: {},
    evol: {},
    total: {
      all: [],
    },
    order: {},
    table_name: QUERY_TABLES.AUTH_PROVIDERS,
  };
};

export const fetchTenantById = async payload => {
  const { tenantId } = payload;
  const request = buildQueryTenant({ tenantId });
  return executeQuery(request);
};

export const fetchApiKeyByTenantId = async payload => {
  const { tenantId } = payload;
  const request = buildQueryApiKey({ tenantId });
  return executeQuery(request);
};

export const fetchAuthProviderById = async payload => {
  const { tenantId } = payload;
  const request = buildQueryAuthProvider({ tenantId });
  return executeQuery(request);
};
